/**
 * メインヘッダー グローバルナビボタン
 * 「.gnavButton > a」に対して処理をする
 * 
 */

export module MainHeaderModule {
  export class Service {
    constructor() {
      document.addEventListener('readCompleteAction', () => {
        Service.setEvent();
      });
    }

    public static setEvent() {
      const $elements = document.querySelectorAll('.gnavButton > a');
      const $body = document.querySelector('body');
      if ($body) {
        $elements.forEach($element => {
          $element.addEventListener('click', ($event) => {
            if ($body.classList.contains('isGnavOpen')) {
              $body.classList.remove('isGnavOpen');
            } else {
              $body.classList.add('isGnavOpen');
            }
          });
        });
      }
    }
  }
}

